import { IconComponentsProps } from './types';

const FilesIcon = ({ fill = 'currentColor', ...props }: IconComponentsProps) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 9H3V2H10V1H3C2.45 1 2 1.45 2 2V9ZM10.65 4.3L13.7 7.35C13.9 7.55 14 7.8 14 8.05V14C14 14.55 13.55 15 13 15H6C5.45 15 5 14.55 5 14V5C5 4.45 5.45 4 6 4H10C10.25 4 10.5 4.1 10.65 4.3ZM12.95 8L10 5V8H12.95ZM6 5V14H13V9H10C9.45 9 9 8.55 9 8V5H6Z"
      fill={fill}
    />
  </svg>
);

export default FilesIcon;
